import React from 'react'
import '../App.css'
import Bodysignup from './signup/bodysignup'
export class Bodyappsignupbody extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        mail:''
    }
    render() { 
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodysignup setStateMailP={this.props.setStateMailP}/>
                </div>
            </div>
        );
    }

}